import { ControlTowerColumn } from './ControlTowerColumn';
import type { OrderView } from './control-tower-utils';

interface ControlTowerBoardProps {
  ingreso: OrderView[];
  produccion: OrderView[];
  despacho: OrderView[];
  onSelectOrder(order: OrderView): void;
}

export function ControlTowerBoard({ ingreso, produccion, despacho, onSelectOrder }: ControlTowerBoardProps) {
  return (
    <section className="grid gap-4 lg:grid-cols-3" aria-label="Tablero de la torre de control">
      <ControlTowerColumn title="Ingreso" tone="amber" orders={ingreso} emptyText="Sin pedidos en ingreso." onSelectOrder={onSelectOrder} />
      <ControlTowerColumn title="Producción" tone="blue" orders={produccion} emptyText="Sin pedidos en producción." onSelectOrder={onSelectOrder} />
      <ControlTowerColumn title="Despacho / Completado" tone="green" orders={despacho} emptyText="Sin pedidos listos o despachados." onSelectOrder={onSelectOrder} />
    </section>
  );
}
